import { ChecklistAnswers, ChecklistAnswerSpec, ChecklistQuestionSpec } from "@nova/schemas"

export const emptyAnswerSpec = (question: ChecklistQuestionSpec): ChecklistAnswerSpec => {
    switch (question.type) {
        case "text":
            return {
                answer: "",
                questionId: question.id,
                type: "text",
            } satisfies ChecklistAnswerSpec<"text">
        case "multi-select":
            return {
                answer: question.options.map(() => false),
                questionId: question.id,
                type: "multi-select",
            } satisfies ChecklistAnswerSpec<"multi-select">
        case "radio":
            return {
                answer: question.options.map(() => false),
                questionId: question.id,
                type: "radio",
            } satisfies ChecklistAnswerSpec<"radio">
        case "user-select":
            return {
                answer: "",
                questionId: question.id,
                type: "user-select",
            } satisfies ChecklistAnswerSpec<"user-select">
        case "aircraft-select":
            return {
                answer: "",
                questionId: question.id,
                type: "aircraft-select",
            } satisfies ChecklistAnswerSpec<"aircraft-select">
        case "header":
            return {
                questionId: question.id,
                type: "header",
            } satisfies ChecklistAnswerSpec<"header">
    }
}

export const createEmptyAnswers = (form: ChecklistQuestionSpec[]) =>
    form.reduce<ChecklistAnswers>((prev, curr) => {
        prev[curr.id] = emptyAnswerSpec(curr)
        return prev
    }, {})

export const isQuestionAnswered = (answer: ChecklistAnswerSpec) => {
    switch (answer.type) {
        case "header":
            return true
        case "text":
            return !!answer.answer
        case "multi-select":
        case "radio":
            return answer.answer.some((v) => !!v)
        case "user-select":
        case "aircraft-select":
            return !!answer.answer
    }
}

export const canSubmitAnswers = ({
    form,
    answers,
}: {
    form: ChecklistQuestionSpec[]
    answers: ChecklistAnswers
}) =>
    form.every((question) => {
        if (!("isRequired" in question) || !question.isRequired) return true
        return question.id in answers && isQuestionAnswered(answers[question.id])
    })
